/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Box, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { partition } from 'lodash';
import { usePromo } from '@/data/Content/_Promos';
import { usePageDataFromId } from '@/data/_PageDataFromId';

export const ProductDetailsPromos: FC = () => {

	const { data:pageData } = usePageDataFromId();
	const { promos } = usePromo(pageData?.tokenValue);

	const [bannerPromos, textPromos] = partition(promos, (promo) => promo?.includes('promotion_type_banner_promotion'));

	const extractHTMLOnly = (htmlString:string) => {
   	 	return htmlString.replace(/<[^>]+>/g, '');
	}
	
	return promos?.length ? (
		<Box sx={{'& *.MuiTypography-root, p':{fontSize:14}}}>
			{textPromos?.map((promoDesc, i) => (
				<Typography key={i} variant="body1" sx={{ color: '#545454'}} gutterBottom mb={2}>
					{promoDesc?.split("~")?.at(0) ?? ''}
					<Tooltip
						title={<Box dangerouslySetInnerHTML={{ __html: promoDesc?.split('~')?.at(1) ?? '' }}></Box>}
						leaveTouchDelay={2000} enterTouchDelay={20}
						arrow
					>
						<InfoOutlinedIcon focusable="true" tabIndex={0} sx={{ color: '#545454', fontSize: '1.3rem' }} aria-label={extractHTMLOnly(promoDesc?.split('~')?.at(1) ?? '') } role="img" aria-hidden={false} />
					</Tooltip>
				</Typography> 
			))}
			{bannerPromos?.map((bannerPromo) =>
				<Box dangerouslySetInnerHTML={{ __html: bannerPromo?.split('~')?.at(1) ?? '' }}></Box>
			)}
		</Box>
	):null;
};